// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"90fc0b2e57ab3f8a2023","488":"2e5820182ba430d823eb","532":"7ea257594c81849b51b2","592":"d88ba599c4b292e6a0f2","736":"b80eeef94ab508e4f5ae"}[chunkId] + ".js";
};